export default __webpack_public_path__ + "static/media/lt-global-logo.1d27b8ec.png";